export default __webpack_public_path__ + "static/media/invite-friend-platform.25e3e052.png";